import { useMemo } from 'react';

import { useChainId } from '@occc-app/Chain/hooks';
import { useGetCampaignsLazy } from '@occc-app/dataAccessLayer/campaign/queries';
import { LazyAutocompleteFieldNotMultiple } from '@occc-app/design-system';

import {
  makeCampaignsFilter,
  mapCampaignsQueryResponseToRawArray,
  mapRawCampaignResponseItemToAutocompleteOption,
} from './campaign-select.utils';
import { CampaignSelectItem, CampaignSelectProps } from './campaign-select.types';

export const CampaignSelect = ({
  disabled,
  name = 'campaign',
  label = 'Campaign',
}: CampaignSelectProps) => {
  const chainId = useChainId();

  const makeQueryFilter = useMemo(() => {
    return makeCampaignsFilter(chainId);
  }, [chainId]);

  return (
    <LazyAutocompleteFieldNotMultiple<
      CampaignSelectItem,
      ReturnType<typeof useGetCampaignsLazy>['response']
    >
      disabled={disabled}
      name={name}
      label={label}
      useLazyQuery={useGetCampaignsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapCampaignsQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawCampaignResponseItemToAutocompleteOption}
      inputProps={{ margin: 'none' }}
      first={100}
    />
  );
};
